import { useDispatch } from 'react-redux'
import { Element } from '../../../../../common/html/element'
import { TextEllipsisStaticLine } from '../../../../../common/textEllipsis/TextEllipsisStaticLine'
import { changeIdActive } from '../../store/slice'

export const PortfolioTd = ({ val, id }) => {
  const dispatch = useDispatch()

  const handleActiveId = () => {
    dispatch(changeIdActive(id))
  }

  return (
    <>
      <Element
        className="cursorPointer"
        style={{ color: '#2C73E8' }}
        onClick={handleActiveId}
      >
        <TextEllipsisStaticLine text={val} isI18n={false} lineClamp={1} />
      </Element>
    </>
  )
}
